export default __webpack_public_path__ + "static/03-5302d54092ab6a04f6e98e379fb3e6d2.svg";